'use client';

import React, { useEffect, useState } from 'react';
import { Container, Row } from 'reactstrap';
import Image from 'next/image';

// import static assets
import Logo from '/public/images/techtarget-logo.svg';
import borderFlash from '/public/backgrounds/border_diagonal.svg';
import { useTranslations } from 'next-intl';
const currentDate = new Date().getFullYear();
function Footer() {
  const [showCookies, setShowCookies] = useState(false);
  useEffect(() => {
    async function gdprApplies() {
      if (window?.['__tcfapi']) {
        await window?.['__tcfapi']('getTCData', 2, function (data: any) {
          console.log(data);
          console.log('on react data.gdprApplies: ' + data.gdprApplies);
          if (data.gdprApplies) {
            console.log('gdprApplies');
            setShowCookies(true);
          } else {
            console.log('gdpr not Applies');
          }
        });
      }
    }
    gdprApplies();
  }, [showCookies]);
  function getGdprId() {
    const currentHost = window.location.host;
    let gdprId;
    // Temp switch statement while we wait for dotvault
    if (currentHost?.includes('.eng')) {
      gdprId = 1035076;
    } else if (currentHost?.includes('.qa')) {
      gdprId = 1027383;
    } else {
      gdprId = 1048617;
    }
    return gdprId;
  }
  const t = useTranslations('Footer');
  return <div className={'site-footer'} data-sentry-component="Footer" data-sentry-source-file="Footer.tsx">
   <Container className={'footer-main g-0 xxl'} data-sentry-element="Container" data-sentry-source-file="Footer.tsx">
    <Row data-sentry-element="Row" data-sentry-source-file="Footer.tsx">
     <div className={'footer-logo-flex'}>
      <Image src={Logo} priority={true} alt={'Techtarget logo'} data-sentry-element="Image" data-sentry-source-file="Footer.tsx" />
     </div>

     <div className={'footer-main-flex'}>
      <div aria-hidden="true" style={{
            backgroundImage: `url(${borderFlash.src})`,
            backgroundRepeat: 'repeat-x',
            width: '100%',
            height: '10px'
          }}></div>

      <div className={'foot-meta'}>
       <p className={'foot-copyright'}>
        {t('Copyright', {
                year: currentDate
              })}
       </p>

       <div className={'footer-links'}>
        <a className={'text-links-sm privacy'} target="_blank" href={'https://www.techtarget.com/privacy-policy/'}>
         {t('PrivacyPolicy')}
        </a>
        <a className={'text-links-sm privacy'} target="_blank" href={'https://techtarget.zendesk.com/hc/en-us/requests/new?ticket_form_id=360004852434'}>
         Do Not Sell or Share My Personal Information
        </a>
        <button id="gdpr_link " className={'text-links-sm'} style={{
                display: showCookies == true ? '' : 'none'
              }} onClick={() => {
                window?.['_sp_'].gdpr.loadPrivacyManagerModal(getGdprId());
              }}>
         {t('CookiePreferences')}
        </button>
       </div>
      </div>
     </div>
    </Row>
   </Container>
  </div>;
}
export default Footer;